module.exports = __webpack_public_path__ + "static/media/food.c8afbe55.jpg";